import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom-v5-compat'

import { usePrevious } from '@/app/helpers'

export const useOrgSwitchGuard = (orgId: number) => {
  const navigate = useNavigate()
  const previousOrgId = usePrevious(orgId)

  useEffect(() => {
    if (previousOrgId && previousOrgId !== orgId) {
      navigate(`/campaigns?page=1`)
    }
  }, [orgId, previousOrgId, navigate])
}
